// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Authentication = function Authentication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.875 5v2.5h6.25V5a3.124 3.124 0 1 0-6.25 0M5 7.5V5a5 5 0 1 1 10 0v2.5h1.25c1.379 0 2.5 1.121 2.5 2.5v7.5c0 1.379-1.121 2.5-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5V10c0-1.379 1.121-2.5 2.5-2.5zM3.125 10v7.5c0 .344.281.625.625.625h12.5a.627.627 0 0 0 .625-.625V10a.627.627 0 0 0-.625-.625H3.75a.627.627 0 0 0-.625.625"
  }));
};
